import Tokens from 'csrf';
import { getCookie, setCookie } from '../client/cookie/cookieService';

const THRESHOLD = 0;
export const SIGN_IN_STR = 'Sign in';
export const CREATE_STR = 'Create account';

const SIGN_IN_BASE_URL = 'https://accounts.realestate.com.au/login';
const SIGN_UP_BASE_URL = 'https://accounts.realestate.com.au/signup';

export const isLockeIntegrationOn = () => {
  const cookieValue = getCookie('lockeIntegration');
  if (isNaN(cookieValue)) {
    return false;
  }
  return cookieValue < THRESHOLD;
};

const getCsrfToken = () => {
  const csrf = getCookie('csrf');
  if (!csrf) {
    const tokens = new Tokens();
    const csrfSecret = tokens.secretSync();
    const csrfValue = tokens.create(csrfSecret);
    setCookie('csrf', csrfValue);
    return csrfValue;
  }
  return csrf;
};

const generateStateParam = (continueUrl) => {
  const lockeCsrf = getCsrfToken();
  const stateParam = JSON.stringify({
    csrf: lockeCsrf,
    continueUrl,
  });
  return new Buffer(stateParam).toString('base64');
};

export const generateLockeSignInUrl = (clientId, redirectUrl, currentPath) =>
  `${SIGN_IN_BASE_URL}?response_type=code&client_id=${clientId}` +
  `&redirect_uri=${redirectUrl}&state=${generateStateParam(currentPath)}`;

export const generateLockeSignUpUrl = (clientId, redirectUrl, currentPath) =>
  `${SIGN_UP_BASE_URL}?response_type=code&client_id=${clientId}` +
  `&redirect_uri=${redirectUrl}&state=${generateStateParam(currentPath)}`;

export const generateLockeUrl = (type, clientId, redirectUrl, currentPath) => {
  if (type === SIGN_IN_STR) {
    return generateLockeSignInUrl(clientId, redirectUrl, currentPath);
  }
  if (type === CREATE_STR) {
    return generateLockeSignUpUrl(clientId, redirectUrl, currentPath);
  }
};
